export const APPLICATION_SET_VOLUME = "application/setVolume";
export const APPLICATION_SET_IS_DARK = "application/setIsDark";
export const APPLICATION_SET_LOADED_SETTINGS = "application/setLoadedSettings";
export const APPLICATION_RESET = "application/reset";
